import { SET_MESSAGE, CLEAR_MESSAGE, SET_DRIVER } from "./types";

export const setMessage = (message) => ({
  type: SET_MESSAGE,
  payload: message,
});

export const setDriver = (driver) => ({
  type: SET_DRIVER,
  payload: driver,
});

export const clearMessage = () => ({
  type: CLEAR_MESSAGE,
});